import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

//const api url from server
import baseUrl from '../base-url';
const API_URL = baseUrl() + "/api/all/";

const getRplPpak = 'sertifikasi-rpl';
const getDetailRplPPAK = 'sertifikasi-rpl/';
const postRplPpakUrl = 'sertifikasi-rpl';
const putRplPpakUrl = 'sertifikasi-rpl/';
const deleteRplPpak = 'sertifikasi-rpl/delete-sertifikasi-rpl/';


class RplPpakService {
    getRplPpak(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getRplPpak + '?pageNo=' + currentPage + '&pageSize=' +  pageSize  + '&filter=' + filter + '&kategoriRpl=PPAK',
            {
                headers: authHeader()
            });
    }
    getDetailRplPPAK(idSertifikasiRpl) {
        return axios.get(
            API_URL + getDetailRplPPAK + idSertifikasiRpl,
            {
                headers: authHeader()
            });
    }

    postRplPpak(formData) {
        // da34dac4-1bac-4eb0-bcdb-00626c4d7118
        return axios
            .post(
                API_URL + postRplPpakUrl,
                formData,
                {
                    headers: authHeader()
                }
            );
    }

    putRplPpak(formData) {
        // da34dac4-1bac-4eb0-bcdb-00626c4d7118
        return axios
            .put(
                API_URL + putRplPpakUrl,
                formData,
                {
                    headers: authHeader()
                }
            );
    }

    deleteRplPpak(formData) {
        return axios
            .delete(
                API_URL + deleteRplPpak + formData, {
                    headers: authHeader()
                }
            );
    }


}

export default new RplPpakService();
